import * as SessionUtils from "./../../../core/session_utils";

/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 02/10/2020
 */
const listRequest = () => {
    return {
        userId: null,
        status: 0,
        page: 1,
        limit: 10,
        invited: SessionUtils.isGuestUser(),
        sessionUser:SessionUtils.getGuestUserToken()
    }

}

export default listRequest;